import { render } from "./useDoc.vue?vue&type=template&id=00bccba9&scoped=true"
import script from "./useDoc.vue?vue&type=script&lang=js"
export * from "./useDoc.vue?vue&type=script&lang=js"

import "./useDoc.vue?vue&type=style&index=0&id=00bccba9&scoped=true&lang=css"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bccba9"]])

export default __exports__